function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.50008 19.0001C4.05236 19.0001 4.50008 18.5524 4.50008 18.0001C4.50008 17.4478 4.05236 17.0001 3.50008 17.0001C2.94779 17.0001 2.50008 17.4478 2.50008 18.0001C2.50008 18.5524 2.94779 19.0001 3.50008 19.0001ZM3.50008 21.0001C5.15693 21.0001 6.50008 19.6569 6.50008 18.0001C6.50008 16.3432 5.15693 15.0001 3.50008 15.0001C1.84322 15.0001 0.500076 16.3432 0.500076 18.0001C0.500076 19.6569 1.84322 21.0001 3.50008 21.0001Z",
  fill: "#101820"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5216 0.992188L19.5216 4.99219L18.1074 6.4064L16.5001 4.79909V12.0001L4.50008 12.0001V16.0001H2.50008V10.0001L14.5001 10.0001V4.8137L12.9074 6.4064L11.4932 4.99219L15.4932 0.992188L15.5074 1.00641L15.5216 0.992188ZM3.49988 2.78474L5.29243 0.992188L6.70665 2.4064L4.9141 4.19895L6.70711 5.99158L5.29304 7.40594L3.49988 5.61317L1.70718 7.40587L0.292969 5.99165L2.08567 4.19895L0.293428 2.40633L1.70779 0.992263L3.49988 2.78474ZM15.4999 16.3855L17.2924 14.593L18.7066 16.0072L16.9141 17.7997L18.7071 19.5924L17.293 21.0067L15.4999 19.2139L13.7072 21.0066L12.293 19.5924L14.0857 17.7997L12.2934 16.0071L13.7078 14.593L15.4999 16.3855Z",
  fill: "#101820"
});

function SvgGamePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePlan);
export default __webpack_public_path__ + "static/media/GamePlan.b89844f8.svg";
export { ForwardRef as ReactComponent };